/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { DeviceCoveragePassiveSpeakerFragment } from './device-coverage-audio-passive-speaker.generated';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceCoverageAudioChannelFragment = { id: string, isAudioChannelNode: 'AudioChannel', description: { index: number, group: Types.AudioChannelGroup, role: Types.AudioChannelRole, constraints: { lobePosition: { fixed: { xPosition: { range: { min: number, max: number, step: number } }, yPosition: { range: { min: number, max: number, step: number } }, zPosition: { range: { min: number, max: number, step: number } } } } | null, microphoneAngle: { fixed: { angle: { range: { min: number, max: number, step: number } } } } | null, gain: { gain: { range: { max: number, min: number, step: number } } } | null, postGateGain: { gain: { range: { min: number, max: number, step: number } } } | null, lobeTalkerHeight: { fixed: { height: { range: { min: number, max: number, step: number } } }, autoFocus: { supported: boolean, height: { range: { min: number, max: number, step: number } } | null } } | null, name: { name: { pattern: string } } | null }, features: { name: { supported: boolean }, coverageViewLock: { supported: boolean }, danteRouteTransmitter: { supported: boolean }, identify: { supported: boolean }, lobeConfiguration: { supported: boolean }, lobePosition: { supported: boolean }, lobeTalkerHeight: { supported: boolean }, lobeWidth: { supported: boolean }, mute: { supported: boolean }, preGateMute: { supported: boolean }, postGateMute: { supported: boolean }, micPolarPattern: { supported: boolean }, microphoneAngle: { supported: boolean }, gain: { supported: boolean }, postGateGain: { supported: boolean }, autoPosition: { supported: boolean }, passiveSpeakers: { supported: boolean }, automixer: { supported: boolean } } }, features: { name: { name: string } | null, coverageViewLock: { enabled: boolean } | null, danteRouteTransmitter: { danteChannelName: string } | null, identify: { identifying: boolean } | null, lobeConfiguration: { enabled: boolean } | null, lobePosition: { fixed: { yPosition: number, xPosition: number, zPosition: number }, autoFocus: { yPosition: number, xPosition: number } | null } | null, lobeTalkerHeight: { fixed: { height: number }, autoFocus: { height: number } | null } | null, lobeWidth: { width: Types.LobeWidth } | null, mute: { muted: boolean } | null, preGateMute: { muted: boolean } | null, postGateMute: { muted: boolean } | null, micPolarPattern: { pattern: Types.MicPolarPattern } | null, microphoneAngle: { fixed: { angle: number }, autoFocus: { angle: number } | null, fixedAngleRange: { max: number, min: number, step: number } | null } | null, gain: { gain: number } | null, postGateGain: { gain: number } | null, autoPosition: { status: Types.AutoPositionStatus } | null, passiveSpeakers: { type: Types.SpeakerType, passiveSpeakers: Array<DeviceCoveragePassiveSpeakerFragment> | null } | null, automixer: { enabled: boolean | null, mode: Types.AutomixMode } | null } };

export type DeviceCoverageAudioChannelUpdateFragment = { id: string, features:
    | { automixer: { enabled: boolean | null, mode: Types.AutomixMode } | null }
    | { coverageViewLock: { enabled: boolean } | null }
    | { danteRouteTransmitter: { danteChannelName: string } | null }
    | { gain: { gain: number } | null }
    | { identify: { identifying: boolean } | null }
    | { lobeConfiguration: { enabled: boolean } | null }
    | { lobePosition: { fixed: { xPosition: number, yPosition: number, zPosition: number } } | null }
    | { lobeTalkerHeight: { fixed: { height: number } } | null }
    | { lobeWidth: { width: Types.LobeWidth } | null }
    | { micPolarPattern: { pattern: Types.MicPolarPattern } | null }
    | { microphoneAngle: { fixed: { angle: number }, autoFocus: { angle: number } | null, fixedAngleRange: { max: number, min: number, step: number } | null } | null }
    | { mute: { muted: boolean } | null }
    | { name: { name: string } | null }
    | { postGateGain: { gain: number } | null }
    | { postGateMute: { muted: boolean } | null }
    | { preGateMute: { muted: boolean } | null }
    | Record<PropertyKey, never>
   };

export type CoverageAudioChannelSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type CoverageAudioChannelSubscriptionOpResult = { nodeChanges:
    | DeviceCoverageAudioChannelFragment
    | DeviceCoverageAudioChannelUpdateFragment
    | Record<PropertyKey, never>
   };

export type UpdateCoverageAudioChannelMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateCoverageAudioChannelMutationOpResult = { updateNodes: Array<
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export const DeviceCoverageAudioChannelFragment = gql`
    fragment DeviceCoverageAudioChannelFragment on AudioChannel {
  isAudioChannelNode: __typename
  id
  description {
    index
    group
    role
    constraints {
      lobePosition {
        fixed {
          xPosition {
            range {
              min
              max
              step
            }
          }
          yPosition {
            range {
              min
              max
              step
            }
          }
          zPosition {
            range {
              min
              max
              step
            }
          }
        }
      }
      microphoneAngle {
        fixed {
          angle {
            range {
              min
              max
              step
            }
          }
        }
      }
      gain {
        gain {
          range {
            max
            min
            step
          }
        }
      }
      postGateGain {
        gain {
          range {
            min
            max
            step
          }
        }
      }
      lobeTalkerHeight {
        fixed {
          height {
            range {
              min
              max
              step
            }
          }
        }
        autoFocus {
          supported
          height {
            range {
              min
              max
              step
            }
          }
        }
      }
      name {
        name {
          pattern
        }
      }
    }
    features {
      name {
        supported
      }
      coverageViewLock {
        supported
      }
      danteRouteTransmitter {
        supported
      }
      identify {
        supported
      }
      lobeConfiguration {
        supported
      }
      lobePosition {
        supported
      }
      lobeTalkerHeight {
        supported
      }
      lobeWidth {
        supported
      }
      mute {
        supported
      }
      preGateMute {
        supported
      }
      postGateMute {
        supported
      }
      micPolarPattern {
        supported
      }
      microphoneAngle {
        supported
      }
      gain {
        supported
      }
      postGateGain {
        supported
      }
      autoPosition {
        supported
      }
      lobeTalkerHeight {
        supported
      }
      passiveSpeakers {
        supported
      }
      automixer {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    coverageViewLock {
      enabled
    }
    danteRouteTransmitter {
      danteChannelName
    }
    identify {
      identifying
    }
    lobeConfiguration {
      enabled
    }
    lobePosition {
      fixed {
        yPosition
        xPosition
        zPosition
      }
      autoFocus {
        yPosition
        xPosition
      }
    }
    lobeTalkerHeight {
      fixed {
        height
      }
      autoFocus {
        height
      }
    }
    lobeWidth {
      width
    }
    mute {
      muted
    }
    preGateMute {
      muted
    }
    postGateMute {
      muted
    }
    micPolarPattern {
      pattern
    }
    microphoneAngle {
      fixed {
        angle
      }
      autoFocus {
        angle
      }
      fixedAngleRange {
        max
        min
        step
      }
    }
    gain {
      gain
    }
    postGateGain {
      gain
    }
    autoPosition {
      status
    }
    passiveSpeakers {
      type
      passiveSpeakers {
        ...DeviceCoveragePassiveSpeakerFragment
      }
    }
    automixer {
      enabled
      mode
    }
  }
}
    ${DeviceCoveragePassiveSpeakerFragment}`;
export const DeviceCoverageAudioChannelUpdateFragment = gql`
    fragment DeviceCoverageAudioChannelUpdateFragment on AudioChannelChange {
  id
  features {
    ... on AudioChannelNameChange {
      name {
        name
      }
    }
    ... on AudioChannelCoverageViewLockChange {
      coverageViewLock {
        enabled
      }
    }
    ... on AudioChannelLobeConfigurationChange {
      lobeConfiguration {
        enabled
      }
    }
    ... on AudioChannelLobePositionChange {
      lobePosition {
        fixed {
          xPosition
          yPosition
          zPosition
        }
      }
    }
    ... on AudioChannelLobeWidthChange {
      lobeWidth {
        width
      }
    }
    ... on AudioChannelLobeTalkerHeightChange {
      lobeTalkerHeight {
        fixed {
          height
        }
      }
    }
    ... on AudioChannelMuteChange {
      mute {
        muted
      }
    }
    ... on AudioChannelPostGateMuteChange {
      postGateMute {
        muted
      }
    }
    ... on AudioChannelPreGateMuteChange {
      preGateMute {
        muted
      }
    }
    ... on AudioChannelMicPolarPatternChange {
      micPolarPattern {
        pattern
      }
    }
    ... on AudioChannelMicrophoneAngleChange {
      microphoneAngle {
        fixed {
          angle
        }
        autoFocus {
          angle
        }
        fixedAngleRange {
          max
          min
          step
        }
      }
    }
    ... on AudioChannelIdentifyChange {
      identify {
        identifying
      }
    }
    ... on AudioChannelDanteRouteTransmitterChange {
      danteRouteTransmitter {
        danteChannelName
      }
    }
    ... on AudioChannelGainChange {
      gain {
        gain
      }
    }
    ... on AudioChannelPostGateGainChange {
      postGateGain {
        gain
      }
    }
    ... on AudioChannelAutomixerChange {
      automixer {
        enabled
        mode
      }
    }
  }
}
    `;
export const CoverageAudioChannelSubscriptionDocument = gql`
    subscription CoverageAudioChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...DeviceCoverageAudioChannelFragment
    ...DeviceCoverageAudioChannelUpdateFragment
  }
}
    ${DeviceCoverageAudioChannelFragment}
${DeviceCoverageAudioChannelUpdateFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CoverageAudioChannelSubscriptionGQL extends Apollo.Subscription<CoverageAudioChannelSubscriptionOpResult, CoverageAudioChannelSubscriptionVariables> {
    override document = CoverageAudioChannelSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCoverageAudioChannelMutationDocument = gql`
    mutation UpdateCoverageAudioChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on AudioChannelOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCoverageAudioChannelMutationGQL extends Apollo.Mutation<UpdateCoverageAudioChannelMutationOpResult, UpdateCoverageAudioChannelMutationVariables> {
    override document = UpdateCoverageAudioChannelMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }